<template>
  <div class="container_box">
    <banner title="新闻中心" text="关注我们的新闻，了解最新咨询和行业信息" imgUrl="https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/banner6.png"></banner>

    <!-- 新闻中心 -->
    <div class="box-con">
      <div class="con">
        <div>
          <div class="box-card">
            <!-- tab按钮 -->
            <span class="tabs" :class="{to_active:isShow === 1}" @click="handleTab(1)">沃时动态</span>
            <span class="tabs" :class="{to_active:isShow === 2}" @click="handleTab(2)">最新资讯</span>
            <!-- 下面的div盒子 -->
            <div v-if="isShow === 1" class="tabs-box">
              <!-- 沃时动态 -->
              <template v-for="(item, index) in trandsList">
                <div class="ours-box" :key="index">
                  <div class="cord" @click="jump(item[0].jumpurl)">
                    <img :src="item[0].imgPath" alt="" />
                    <h4 v-text="item[0].title"></h4>
                    <h5 v-text="item[0].time"></h5>
                    <p v-text="item[0].desc"></p>
                    <button class="btn">更多</button>
                    <div class="line"></div>
                  </div>
                  <div class="cord" @click="jump(item[1].jumpurl)">
                    <img :src="item[1].imgPath" alt="" />
                    <h4 v-text="item[1].title"></h4>
                    <h5 v-text="item[1].time"></h5>
                    <p v-text="item[1].desc"></p>
                    <button class="btn">更多</button>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="isShow === 2" class="tabs-box">
              <!-- 最新资讯 -->
              <template v-for="(item, index) in infoList">
                <div class="ours-box" :key="index">
                  <div class="cord" @click="jump(item[0].jumpurl)">
                    <img :src="item[0].imgPath" alt="" />
                    <h4 v-text="item[0].title"></h4>
                    <h5 v-text="item[0].time"></h5>
                    <p v-text="item[0].desc"></p>
                    <button class="btn">更多</button>
                    <div class="line"></div>
                  </div>
                  <div class="cord" v-if="item[1]" @click="jump(item[1].jumpurl)">
                    <img :src="item[1].imgPath" alt="" />
                    <h4 v-text="item[1].title"></h4>
                    <h5 v-text="item[1].time"></h5>
                    <p v-text="item[1].desc"></p>
                    <button class="btn">更多</button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from './banner.vue'

export default {
  components: {
    banner
  },
  mounted(){

  },
  data() {
    return {
      isShow: 1,
      trandsList: [
        [
          { title: "沃时动态 | 沃时派客再获高新技术企业证书", time: "2021年3月11日", desc: "沃时派客再次荣获由上海市科学技术委员会、上海市财政局、国家税务总局、上海市税务局联合颁发的高新技术企业证书，这是对沃时派客在科技领域贡献的又一认可。", jumpurl: "https://mp.weixin.qq.com/s/wCjyW9kTaEfGfiDSKMQJ1g", imgPath: require("@/assets/news/n8.jpeg") },
          { title: "沃时动态 | 变局中开新局，服务中育新机", time: "2021年3月5日", desc: "2021年3月2日,于上海市包装技术协会十届二次代表大会暨理事会星级企业颁证表彰上，沃时派客凭借其在包装行业转型发展过程中的创新性表现，荣获上海市包装技术协会物流包装专业五星级企业。此外，由于在疫情防控期间作出了突出贡献，沃时派客还被授予——抗疫先进单位的荣誉称号。", jumpurl: "https://mp.weixin.qq.com/s/T9N_SelzAKAdv9sXl0eP8Q", imgPath: require("@/assets/news/n7.jpg") }
        ],
        [
          { title: "沃时动态 | 沃时派客荣获“五星级企业”称号", time: "2021年2月9日", desc: "上海市包装技术协会第六届星级包装企业评选结果公示。沃时派客荣获物流包装专业“五星级企业”称号！", jumpurl: "https://mp.weixin.qq.com/s/wvpadVUUHu5VDqnFMXqXOg", imgPath: require("@/assets/news/n6.jpg") },
          { title: "沃时动态 | 专题速递——剖析数字化变革核心", time: "2021年2月5日", desc: "沃时派客作为中国数字化包装企业的先行者，近期获得《中国企业报》和《消费日报》两大权威媒体的关注，并有幸为包装企业数字化转型而发声！", jumpurl: "https://mp.weixin.qq.com/s/jgKMGIibKhUrpaxMkVvHvw", imgPath: require("@/assets/news/n5.jpg") }
        ]
      ],
      infoList: [
        [
          { title: "包装前线 | 后疫情时代，数字化转型助力企业价值再释放", time: "2021年3月11日", desc: "受新冠疫情影响，包装生产由传统人工作业模式加速向包装自动化转型，以积极应对疫情条件下人力受限的状况。同时，以医疗为代表的领域开始向线上发展，这一改变同样推动了供应链上下游变化，也对物流包装提出了新的需求与挑战", jumpurl: "https://mp.weixin.qq.com/s/KJzRqftCKRByCTf33nfbZA", imgPath: require("@/assets/news/n9.png") },
          { title: "女神节特辑 | 为女性力量喝彩", time: "2021年3月5日", desc: "当今社会，女性力量在各行各业迸发出耀眼的光芒，正如二十世纪新闻女王奥莉娅娜·法拉奇所言：“我们头脑清醒，有自知之明。我们是一片成熟的谷物，不再是青涩未熟的，不再是干瘪的。”  沃时派客在这里预祝大家女神节快乐～并通过访谈，聚焦到沃时女神们身上，分享新一代女性力量的高光时刻！", jumpurl: "https://mp.weixin.qq.com/s/HtF8VotA2BwzIHmaBopGPQ", imgPath: require("@/assets/news/n10.jpeg") },
        ],
        [
          { title: "沃时一刻 | 颠覆传统，采购数字化转型加速包装服务升级", time: "2021年2月26日", desc: "数字化不仅仅是意识形态上的思维模式，更是落地实践的关键路径。本期，我们将从沃时派客采购部出发，深入解读供应链层面的数字化转型。", jumpurl: "https://mp.weixin.qq.com/s/pSHl6F19Rfk2kI9R2TAJhQ", imgPath: require("@/assets/news/n11.png") },
          { title: "沃时包装课堂 | 关于物流包装安全的小秘密", time: "2021年2月19日", desc: "防震包装是保障物流包装安全的关键一环，有效减缓内装物受到冲击和振动，保护其免受损坏。那市面常用的防震包装有哪些？它们又各自拥有怎样的特点呢？", jumpurl: "https://mp.weixin.qq.com/s/x4mBq8wucxdYbnuceaO4Cw", imgPath: require("@/assets/news/n12.png") },
        ],
        [
          { title: "沃时包装课堂 | 创业型公司的“生长因子”", time: "2021年2月19日", desc: '沃时派客作为创业型公司之一，能够做到逆势而上，其“生长因子”是什么呢？', jumpurl: "https://mp.weixin.qq.com/s/v8f0DQmZDRFqZ-GoIEl2HQ", imgPath: require("@/assets/news/n4.jpg") },
          { title: "沃时包装课堂 | 瓦楞纸箱小科普", time: "2021年2月9日", desc: "瓦楞纸箱作为物流包装中最重要的材料之一，你了解多少？而物流包装又为什么偏爱瓦楞纸箱？接下来，跟着沃时派客一起来学习下吧！", jumpurl: "https://mp.weixin.qq.com/s/e4QBN68ZlxBPy2AuZC2PJg", imgPath: require("@/assets/news/5.jpg") },
        ],
        [
          { title: "沃时一刻 | 以研发视角，走进包装人的一天", time: "2021年2月5日", desc: "数字化大背景下，传统包装企业已逐渐跟不上时代的步伐。以沃时派客为代表的数字化包装供应链整合平台型科技企业走入市场。接下来，将从研发视角为大家展示企业在日常运营中的数字化落地实践。", jumpurl: "https://mp.weixin.qq.com/s/5jBfUJG9NOCN5ELRwqroRQ", imgPath: require("@/assets/news/3.jpg") },
          { title: "沃时包装课堂 | 沃时派客与数字化的智慧碰撞", time: "2021年1月29日", desc: "行业数字化转型成为趋势，沃时派客助力上下游产业数字化", jumpurl: "https://mp.weixin.qq.com/s/lxXtO1eZWm7XUgRb2FNaUA", imgPath: require("@/assets/news/n3.jpg") },
        ],
        [
          { title: "沃时包装课堂 | 包装行业的前世今生", time: "2021年1月22日", desc: "包装发展史可分为原始包装的萌芽、古代包装、近代包装、现代包装四阶段。", jumpurl: "https://mp.weixin.qq.com/s/Pw3H8tQstsZ5NRindTOjvg", imgPath: require("@/assets/news/1.jpg") },
          { title: "沃时一刻 | 沃时派客，让包装变得更简单", time: "2021年1月12日", desc: "沃时派客，让包装变得更简单", jumpurl: "https://mp.weixin.qq.com/s/AHx63lTZRyUb7EIMldG4rA", imgPath: require("@/assets/news/n1.jpg") },
        ],
        [
          { title: "包装前线 | 细数2021包装行业发展的十大趋势", time: "2021年1月12日", desc: "2020年，原有传统包装市场形成震荡，多行业趋势相互结合，多元化行业诉求不断增强。沃时派客站在行业转向风口，以行业内外环境为基础，结合包装领域专家的建议针对包装行业2021的发展趋势作出了预判。", jumpurl: "https://mp.weixin.qq.com/s/tPeWwfrwnqx2eGzuI1qG-Q", imgPath: require("@/assets/news/6.jpg") }
        ]
      ]
    };
  },
  methods: {
    handleTab(val) {
      this.isShow = val;
    },
    jump: function (url) {
      window.open(url, "_blank")
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  background: #fff;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  .box-con {
    // position: relative;
    // bottom: 48px;
    display: flex;
    justify-content: center;
    .con {
      width: 1200px;
      background: #ffffff;
      text-align: center;
      padding: 45px 0px;

      // span {
      //   font-size: 42px;
      //   font-weight: 500;
      //   height: 44px;
      //   // font-size: 32px;
      //   // margin: 0px 0px 6px 0px;
      //   color: #333333;
      //   line-height: 44px;
      // }
    }
    .box-card {
      .to_active {
        background: #3359cc;
        font-weight: 600;
        color: #ffffff;
      }
      .tabs {
        cursor: pointer;
        display: inline-block;
        border: 1px solid #dad8d8;
        line-height: 40px;
        width: 160px;
        height: 40px;
        // margin: 50px 12px;
        margin: 50px 12px 0px 12px;
        font-size: 16px;
      }
      .tabs-box {
        margin: 0 auto;
        width: 1024px;
        // background: pink;
        .ours-box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          // background: pink;
          // border-bottom: 2px dotted#979797;
          .cord:hover {
            background: #f1f2f5;
          }
          .cord {
            width: 474px;
            padding: 40px 0px;
            text-align: left;
            cursor: pointer;
            img {
              width: 450px;
              height: 210px;
              object-fit: cover;
              object-position: top;
              margin: 12px 12px 24px;
            }
            h4 {
              font-size: 16px;
              line-height: 22px;
              padding-left: 12px;
            }
            h5 {
              font-size: 14px;
              line-height: 22px;
              padding-left: 12px;
              padding-top: 6px;
              color: #666;
            }
            p {
              padding: 14px 12px 14px;
              width: 450px;
              font-size: 12px;
              color: #333333;
              line-height: 18px;
              text-indent: 24px;
            }
            .btn {
              width: 90px;
              height: 30px;
              border-radius: 15px;
              line-height: 30px;
              background: #3359cc;
              border: none;
              color: #ffffff;
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
